// src/lib/useVoileEcran.js — UN VOILE EST OUVERT (correction Dimitri 22/08).
//
// La colonne sticky de la frise (téléphone) passe AU-DESSUS du voile des
// feuilles — anomalie de compositing (le z n'y peut rien, mesuré). Le remède :
// chaque feuille/panneau SIGNALE son ouverture en posant la classe
// `fbz-voile-ouvert` sur <body> ; la CSS de la frise dé-épingle alors la
// colonne (position:static) — plus rien de la frise ne reste lisible sous le
// voile. COMPTEUR : deux feuilles empilées ne s'éteignent pas l'une l'autre.
//
// Usage : useVoileEcran() en tête de toute feuille/panneau à voile plein
// écran. Ordinateur : la classe est posée aussi mais la CSS ne vit que ≤860.

import { useEffect } from 'react'

let compte = 0

export default function useVoileEcran(actif = true) {
  useEffect(() => {
    if (!actif) return undefined
    compte += 1
    document.body.classList.add('fbz-voile-ouvert')
    return () => {
      compte = Math.max(0, compte - 1)
      if (compte === 0) document.body.classList.remove('fbz-voile-ouvert')
    }
  }, [actif])
}
